import types from "actions/types"
import {combineReducers} from "redux"

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_MARK_PURCHASE_ORDER_PAID_DIALOG:
      return true
    case types.HIDE_MARK_PURCHASE_ORDER_PAID_DIALOG:
      return false
    default:
      return state
  }
}

export const purchaseOrder = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_MARK_PURCHASE_ORDER_PAID_DIALOG:
      return action.purchaseOrder
    case types.HIDE_MARK_PURCHASE_ORDER_PAID_DIALOG:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  purchaseOrder,
})
